import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(
    private loaderService: LoaderService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const re = '/file-upload/mutual-funds';
    // Exclude interceptor for logged in user:
    if (req.url.search(re) === -1 ) {
      this.loaderService.show();

      return next.handle(req).pipe(
        finalize((): void => this.loaderService.hide())
      );
    }

    return next.handle(req);
  }

}
